import SEOHead from "@/components/feature/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Hero from "@/components/feature/Hero";
import BandeauUrgence from "@/components/feature/BandeauUrgence";
import Services from "@/components/feature/Services";
import PourquoiNous from "@/components/feature/PourquoiNous";
import Pannes from "@/components/feature/Pannes";
import Marques from "@/components/feature/Marques";
import Zones from "@/components/feature/Zones";
import Avis from "@/components/feature/Avis";
import Tarifs from "@/components/feature/Tarifs";
import Formulaire from "@/components/feature/Formulaire";
import Carte from "@/components/feature/Carte";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";

export default function Home() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Réparation Volet Roulant Strasbourg | Dépan'Volets Bas-Rhin"
        description="Dépan'Volets : réparation, motorisation et pose de volet roulant à Strasbourg et dans le Bas-Rhin. Toutes marques, devis gratuit, 24h. 03 74 47 32 40."
        path="/"
        type="website"
        breadcrumbs={[{ label: "Accueil" }]}
      />
      <Navbar />
      <main>
        <Hero />
        <DiagnosticVideo />
        <BandeauUrgence />
        <Services />
        <PourquoiNous />
        <Pannes />
        <Marques />
        <Zones />
        <Avis />
        <Tarifs />
        <Formulaire />
        <Carte />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}